import * as React from 'react'

import { Box, Button, Section } from '@factorialco/deprecated-design-system'
import {
  SettingsPayrollEmployeeGroupEmployeeFragment,
  SettingsPayrollEmployeeGroupFragment,
} from 'generated/resources/graphql'
import isEmpty from 'lodash/isEmpty'

import { observer } from 'mobx-react'

import createComputed from 'modules/core/hooks/createComputed'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import { matchText } from 'modules/core/lib/stringUtils'

import EmployeeGroupSearchList from './components/EmployeeGroupSearchList'

interface Props {
  selectedEmployeeGroup: SettingsPayrollEmployeeGroupFragment
}

const useFilterEmployees = createComputed(
  (employees: SettingsPayrollEmployeeGroupEmployeeFragment[], search: string) => {
    if (!search || isEmpty(search)) return employees

    return employees.filter((employee) => matchText(search, employee.fullName))
  }
)

const EmployeeGroupsEmployees = ({ selectedEmployeeGroup }: Props) => {
  const { navigation } = useNavigation()

  const [search, setSearch] = React.useState('')

  const filteredEmployees = useFilterEmployees(selectedEmployeeGroup.employees, search).get()

  const onSearch = (event: React.ChangeEvent<HTMLInputElement>) => setSearch(event.target.value)

  const addTo = navigation.settings.legalEntitiesId.employeeGroups.employeeGroupId.assign.fullPath({
    id: selectedEmployeeGroup.legalEntityId,
    employee_group_id: selectedEmployeeGroup.id,
  })

  return (
    <Section.FullWidth
      illustration="group"
      title={i18n.t('settings.legal_entities.legal_entity.employee_group.employees.title')}
      description={i18n.t(
        'settings.legal_entities.legal_entity.employee_group.employees.description',
        {
          name: selectedEmployeeGroup.name,
        }
      )}
    >
      <Box gap="s32">
        <Button.Router to={addTo} type="secondary">
          {i18n.t('settings.legal_entities.legal_entity.employee_group.assign.action')}
        </Button.Router>
        {selectedEmployeeGroup.employees.length > 0 && (
          <EmployeeGroupSearchList
            search={search}
            onSearch={onSearch}
            employees={filteredEmployees}
          />
        )}
      </Box>
    </Section.FullWidth>
  )
}

export default observer(EmployeeGroupsEmployees)
